<template lang="pug">
.audit-versions__item
  .audit-versions__item__title(@click="showContent = !showContent")
    div(style="display: flex")
      i.el-icon-caret-bottom(v-if="showContent")
      i.el-icon-caret-right(v-else)
    div
      span(style="margin: 0 10px 0 5px") {{ item.date | formatDate }}
      span {{ item.name }}
      span(style="margin-left: 20px") {{ $t(item.struct_group_name) }} {{ item.status === 0 ? $t('拒绝') : $t('通过')  }}
  transition(name="fade")
    .audit-versions__item__content(v-if="showContent")
      el-row(:gutter="20")
        el-col(style="width: 80px") {{ $t('项目信息') }}:
        el-col.text-left(:span="12")
          el-button(
            type="text"
            @click="showDialog = true"
          ) {{ $t('查看详情') }}
      el-row(:gutter="20")
        el-col(style="width: 80px") {{ $t('备注') }}:
        el-col.text-left(:span="12")
          display-text-container(:text="item.comment")
  history-detail-dialog(
    :visible="showDialog"
    :versionId="item.versionId"
    @close="showDialog = false"
  )
</template>

<script>
import { formatDate } from '@/umcc/util'
import DisplayTextContainer from '@/components/DisplayTextContainer'
import HistoryDetailDialog from '../HistoryDetailDialog'

export default {
  components: {
    DisplayTextContainer,
    HistoryDetailDialog
  },
  props: {
    item: {
      type: Object
    },
    auditType: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      showContent: false,
      quotationListVisible: false,
      showDialog: false
    }
  },
  filters: {
    formatDate
  },
  computed: {
    attachmentType () {
      switch (this.auditType) {
        case 2:
          return this.$t('附件')
        case 7:
        case 8:
        case 9:
        case 10:
        case 11:
          return this.$t('结案信息')
        default:
          return this.$t('附件')
      }
    }
  }
}
</script>

<style lang="stylus">
.audit-versions__item
  width 700px
  margin-bottom 10px
  margin-top 10px
  border 1px solid #d9d9d9
  .quotation
    width calc(100% - 150px)

  .audit-versions__item__title
    display flex
    align-items center
    background #f7f7f7
    padding 0 30px
    height 38px
    border-bottom 1px solid #d9d9d9
    span
      color #2c3031
      font-size 14px
      font-weight 500
    i
      color #595959
      font-size 20px
  .audit-versions__item__content
    padding 0 30px

  .fade-enter-active, .fade-leave-active
    transition opacity .3s

  .fade-enter, .fade-leave-to
    opacity 0

</style>
